/** Palette alignée sur App\Service\ProviderPlaceColorService::PALETTE */
export const PROVIDER_PLACE_COLOR_PALETTE = [
  '#1976d2',
  '#2e7d32',
  '#ed6c02',
  '#9c27b0',
  '#d32f2f',
  '#0288d1',
  '#00796b',
  '#f57c00',
  '#7b1fa2',
  '#c2185b',
  '#1565c0',
  '#388e3c',
  '#ef6c00',
  '#6a1b9a',
  '#ad1457',
] as const;

export function defaultProviderPlaceColorForIndex(index: number): string {
  const palette = PROVIDER_PLACE_COLOR_PALETTE;
  const i = Math.max(0, index);
  return palette[i % palette.length];
}

export function defaultProviderPlaceColorForId(placeId: number): string {
  return defaultProviderPlaceColorForIndex(Math.max(0, placeId - 1));
}

export function normalizeProviderPlaceColor(color: string | null | undefined): string | null {
  if (color == null) return null;
  const trimmed = color.trim();
  if (!/^#[0-9A-Fa-f]{6}$/.test(trimmed)) return null;
  return trimmed.toLowerCase();
}

export function resolveProviderPlaceColor(
  storedColor: string | null | undefined,
  placeId: number
): string {
  return normalizeProviderPlaceColor(storedColor) ?? defaultProviderPlaceColorForId(placeId);
}

export type ProviderPlaceColorSource = {
  id?: number;
  color?: string | null;
  display_color?: string | null;
};

export function getProviderPlaceDisplayColor(place: ProviderPlaceColorSource | null | undefined): string {
  if (!place) return '#757575';
  if (place.display_color && normalizeProviderPlaceColor(place.display_color)) {
    return place.display_color;
  }
  if (place.color && normalizeProviderPlaceColor(place.color)) {
    return place.color;
  }
  if (place.id != null) {
    return defaultProviderPlaceColorForId(place.id);
  }
  return '#757575';
}

/** Fond léger + bordure pour chips / badges lieu. */
export function providerPlaceColorSx(color: string) {
  return {
    borderColor: color,
    color,
    bgcolor: `${color}18`,
  } as const;
}
